import React from 'react';
import { Table } from 'antd';

export const RBHTable = (props: any) => {
  return (
    <Table {...props}></Table>
  );
};

export default RBHTable;
